import { ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackHeight, StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { ROUTE } from "../../routes";
import { ACTION } from "../../platformDashboard/dashboard/types";
export const PlatformSideNav = async (routeId) => {
    const DS = {
        sideNav: {
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.FULL,
            type: StackType.column,
            padding: {
                left: SizeTypeTokens.XL,
                top: SizeTypeTokens.Size32,
            },
            borderConfig: {
                borderColor: ColorTokens.Grey_Milk,
                borderWidth: {
                    right: SizeTypeTokens.XS,
                },
            },
            widgetItems: [
                { id: 'dashboardStack', type: WIDGET.STACK },
                { id: 'spaceSB3', type: WIDGET.SPACE },
                { id: 'leadsStack', type: WIDGET.STACK },
                { id: 'spaceSB0', type: WIDGET.SPACE },
                { id: 'activeCustomerStack', type: WIDGET.STACK },
                { id: 'spaceSB5', type: WIDGET.SPACE },
                { id: 'linkedPartnerStack', type: WIDGET.STACK },
                { id: 'spaceSB5', type: WIDGET.SPACE },
            ],
        },
        linkedPartnerStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'referredPartnerStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB6', type: WIDGET.SPACE },
                { id: 'referredPartnerStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'referredPartnerPage',
                    widgetId: 'renderWidgetGroup',
                    routeId: ROUTE.PLATFORM_LINKED_PARTNERS,
                },
            },
        },
        dashboardStackText: {
            label: 'Dashboard',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: '400',
            lineHeight: 20,
            color: routeId === ROUTE.PLATFORM_DASHBOARD
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        activeCustomersText: {
            label: 'Active Customers',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: '400',
            lineHeight: 20,
            color: routeId === ROUTE.PLATFORM_ACTIVE_CUSTOMERS
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        dashboardStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'dashBoardStackIcon', type: WIDGET.ICON },
                { id: 'spaceSB4', type: WIDGET.SPACE },
                { id: 'dashboardStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'dashboardLegacy',
                    widgetId: 'renderWidgetGroup',
                    routeId: ROUTE.PLATFORM_DASHBOARD,
                },
            },
        },
        activeCustomersStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'activeCustomersIcon', type: WIDGET.ICON },
                { id: 'spaceSB4', type: WIDGET.SPACE },
                { id: 'activeCustomersText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'activeCustomers',
                    widgetId: 'renderWidgetGroup',
                    routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                },
            },
        },
        referredPartnerStackText: {
            label: 'Linked partners',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PLATFORM_LINKED_PARTNERS ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.PLATFORM_LINKED_PARTNERS
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        dashBoardStackIcon: {
            name: IconTokens.Grid_View,
            color: routeId === ROUTE.PLATFORM_DASHBOARD ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        activeCustomersIcon: {
            name: IconTokens.Leads,
            size: IconSizeTokens.LG,
            color: routeId === ROUTE.PLATFORM_ACTIVE_CUSTOMERS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        referredPartnerStackIcon: {
            name: IconTokens.LinkedPartners,
            color: routeId === ROUTE.PLATFORM_LINKED_PARTNERS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        leadsStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'leadsStackIcon', type: WIDGET.ICON },
                { id: 'leadsStackSpace0', type: WIDGET.SPACE },
                { id: 'leadsStackText', type: WIDGET.TEXT },
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'leadPage',
                    widgetId: 'renderWidgetGroup',
                    routeId: ROUTE.PLATFORM_LEADS,
                },
            },
        },
        activeCustomerStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'activeCustomerIcon', type: WIDGET.ICON },
                { id: 'activeCustomerSpace0', type: WIDGET.SPACE },
                { id: 'activeCustomerText', type: WIDGET.TEXT }
            ],
            action: {
                routeId: routeId,
                type: ACTION.CHANGE_TAB,
                payload: {
                    value: 'activeCustomerPage',
                    widgetId: 'renderWidgetGroup',
                    routeId: ROUTE.PLATFORM_ACTIVE_CUSTOMERS,
                },
            },
        },
        leadsStackIcon: {
            name: IconTokens.Lead2,
            color: routeId === ROUTE.PLATFORM_LEADS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        leadsStackText: {
            label: 'Leads         ',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PLATFORM_LEADS ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.PLATFORM_LEADS
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        activeCustomerIcon: {
            name: IconTokens.Leads,
            size: IconSizeTokens.LG,
            color: routeId === ROUTE.PLATFORM_ACTIVE_CUSTOMERS ? ColorTokens.Primary_100 : ColorTokens.Grey_Charcoal,
        },
        activeCustomerText: {
            label: 'Active customers',
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.SM,
            fontWeight: routeId === ROUTE.PLATFORM_ACTIVE_CUSTOMERS ? '600' : '400',
            lineHeight: 20,
            color: routeId === ROUTE.PLATFORM_ACTIVE_CUSTOMERS
                ? ColorTokens.Primary_100
                : ColorTokens.Grey_Charcoal,
        },
        spaceSB0: {
            size: SizeTypeTokens.XXXL,
        },
        spaceSB3: {
            size: SizeTypeTokens.XXXL,
        },
        spaceSB4: {
            size: SizeTypeTokens.XL,
        },
        spaceSB5: {
            size: SizeTypeTokens.XXXL,
        },
        spaceSB6: {
            size: SizeTypeTokens.XL,
        },
        leadsStackSpace0: {
            size: SizeTypeTokens.XL,
        },
        activeCustomerSpace0: {
            size: SizeTypeTokens.XL,
        },
    };
    return DS;
};
